import * as React from 'react';
import { useEffect, useState } from 'react';
import fetchEvents from '@/utils/functions/wordpress/fetchEvents';
import UpcomingEvent from '@/components/sections/Right/UpcomingEvent';
import type { Event } from '@/types/ArticleType';

type UpcomingEventsProps = {
    className?: string;
    initialEvents?: Event[];
};

const UpcomingEvents = (props: UpcomingEventsProps) => {
    const { className, initialEvents } = props;
    const [upcomingEvents, setUpcomingEvents] = useState<Event[]>(initialEvents || []);

    useEffect(() => {
        fetchEvents(2, true).then(fetchedEvents => fetchedEvents.length > 0 && setUpcomingEvents(fetchedEvents));
    }, []);

    return (
        <div className={className}>
            {upcomingEvents.map(event => (
                <UpcomingEvent
                    key={event.slug}
                    className="flex flex-col justify-start items-start flex-grow-0 flex-shrink-0 border-t"
                    header="upcoming event"
                    title={event.title}
                    description={event.excerpt}
                    location={event.customFields?.location || ''}
                    date={event.customFields?.text_date || ''}
                    learnMoreUrl={`/event/${event.slug}`}
                    registerUrl={
                        event.customFields.registration_button_link?.url ||
                        event.customFields.header_button_1_link?.url ||
                        ''
                    }
                />
            ))}
        </div>
    );
};

export default UpcomingEvents;
